import { Box, styled } from '@mui/material';

export const FilterSection = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  paddingLeft: '0.5rem',
  marginLeft: '0.5rem',
  borderLeft: `1px solid ${theme.palette.custom.OV.sys.outline}`,
  whiteSpace: 'nowrap',
  flexShrink: 0,
  ':hover': { opacity: 0.5 },
}));
